import React, { useEffect, useState, useCallback } from 'react';
import CustomTable from 'src/components/App/AppGrid/CustomTable/CustomTable';
import {
  Avatar,
  Box,
  Typography,
  alpha,
  styled,
} from '@mui/material';
import Welcome from '../components/patient/Welcome';
import theme from 'src/config/theme';
import { ReactComponent as Edit2 } from '../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import CustomCard from 'src/modules/app/components/CustomCard/AppointmentCard';
import NoDataFound from '../components/NoDataFound/NoDataFound';
import { useDispatch } from 'react-redux';
import { getBillingRequest, getSummaryRequest } from '../../../modules/app/store/appActions';
import storage from 'src/utils/storageUtils';
import RightSidebar from '../../../components/App/RIghtSidebar/RightSidebar';
import BillingCard from '../components/CustomCard/BillingCard';
import useResponsive from 'src/components/hooks/useResponsive';
import AddBilling from '../components/LefSidebarForms/AddBilling/AddBilling';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import dayjs from 'dayjs';
export const AvatarIcon = styled(Avatar)({
  width: '64px',
  height: '64px',
  padding: '10px',
  borderRadius: '40px',
  background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
  marginBottom: '5px',
});

const columns = [
  {
    id: 'paymentfor',
    label: 'Payment For',
    sx: {
      "& .css-axw7ok": { justifyContent: 'flex-start !important' },
      textAlign: 'left !important',
    },
  },
  {
    id: 'amount',
    label: 'Amount',
    sx: { "& .css-axw7ok": { justifyContent: 'center' } },
  },
  {
    id: 'addedDate',
    label: 'Added Date',
    sx: { "& .css-axw7ok": { justifyContent: 'center' } },
  },
  {
    id: 'paymenttype',
    label: 'Payment Type',
    sx: { "& .css-axw7ok": { justifyContent: 'center' } },
  },
  {
    id: 'paymentmethod',
    label: 'Payment Method',
    sx: { "& .css-axw7ok": { justifyContent: 'center' } },
  },
];

const BillingContainer = () => {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const [isCardView, setIsCardView] = useState(false);
  const [billingData, setBillingData] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [summary, setSummary] = useState({
    totalAmount: 0,
    takenAmount: 0,
    pendingAmount: 0,
  });

  const fetchBillings = useCallback(() => {
    const token = storage.get('TOKEN');
    const fetchData = async () => {
      const params = {
        page: page + 1,
        limit: perPage,
      };
      const response = await new Promise((resolve, reject) =>
        dispatch(getBillingRequest({ token, params }, resolve, reject))
      );
      if (response?.data) {
        setBillingData(response.data);
      }
      if (response?.meta?.totalRecords) {
        setTotalCount(response.meta.totalRecords);
      }
    };
    fetchData();
  }, [dispatch, page, perPage]);

  useEffect(() => {
    fetchBillings();
  }, [fetchBillings]);

  useEffect(() => {
    const token = storage.get('TOKEN');
    dispatch(getSummaryRequest(token,
      (res) => {
        setSummary(res.summary); // <-- set summary state
      },
      (err) => {
        console.error('Failed to fetch summary', err);
      }
    ));
  }, [dispatch]);


  const data = billingData.map((item) => {
    const isRefund = item.amount < 0;
    return {
      id: item.id,
      paymentfor: item.paymentFor,
      amount: (
        <Box sx={{ color: isRefund ? 'red' : 'green', fontWeight: 'bold' }}>
          {isRefund ? `- ₹${Math.abs(item.amount)}` : `+ ₹${item.amount}`}
        </Box>
      ),
      addedDate: dayjs(item.date).format("DD-MM-YYYY"),

      paymenttype: item.type || 'N/A',
      paymentmethod: item.method || 'N/A',
    };
  });

  const actions = [
    // {
    //   label: 'Edit',
    //   icon: <Edit2 />,
    //   onClick: (row) => alert(`Editing billing for ${row.paymentfor}`),
    // },
    // {
    //   label: 'Cancel',
    //   icon: <Close width={isMobile || isTablet ? 18 : 24}
    //     height={isMobile || isTablet ? 18 : 24} />,
    //   onClick: (row) => alert(`Cancelling billing for ${row.paymentfor}`),
    // },
  ];

  return (
    <>
      <Welcome
        category="billing"
        setIsCardView={setIsCardView}
        isCardView={isCardView}
        updateBillings={fetchBillings}
      />
      <Box sx={{ mb: 16 }} />


      <Box sx={{ display: 'flex', gap: isMobile || isTablet ? '5px' : 3, marginX: 2, marginTop: 2 }}>
        <Box sx={{ flex: 1, padding: 2, backgroundColor: '#E3F2FD', borderRadius: 2 }}>
          <Typography sx={{
            [theme.breakpoints.down('md')]: {
              ...theme.mobileTypography.h5,
            },
          }}>Total Amount:</Typography><br /> ₹{summary.totalAmount.toLocaleString()}
        </Box>
        <Box sx={{ flex: 1, padding: 2, backgroundColor: '#E8F5E9', borderRadius: 2 }}>
          <Typography sx={{
            [theme.breakpoints.down('md')]: {
              ...theme.mobileTypography.h5,
            },
          }}>Taken Amount:</Typography><br /> ₹{summary.takenAmount.toLocaleString()}
        </Box>
        <Box sx={{ flex: 1, padding: 2, backgroundColor: '#FFF3E0', borderRadius: 2 }}>
          <Typography
            sx={{
              [theme.breakpoints.down('md')]: {
                ...theme.mobileTypography.h5,
              },
            }}
          >Pending Amount:</Typography><br /> ₹{summary.pendingAmount.toLocaleString()}
        </Box>
      </Box>
      <Box
        sx={{
          height: 'calc(100vh - 240px)',
          margin: 2,
          boxShadow: isMobile || isTablet || isCardView || isCardView ? 'none' : theme.shadows[1],
          borderRadius: '10px',
          border: isMobile || isTablet || isCardView || isCardView ? 'none' : `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
          backgroundColor: isMobile || isTablet || isCardView ? 'none' : theme.palette.gery.white,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: (isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'space-between',
          alignItems: (isMobile || isTablet || isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'none',
          position: 'relative',
          maxHeight: 'calc(100vh - 240px)'
        }}
      >


        {(isMobile || isTablet || isCardView) ? (
          data.length === 0 ? (
            <NoDataFound
              title="No Billing Found!"
              buttonText="Add Billing"
              buttonIcon={Add}
              onClick={handleOpen}
            />
          ) : (
            <BillingCard
              data={data}
              page={page}
              perPage={perPage}
              setPage={setPage}
              totalCount={totalCount}
            />
          )
        ) : (
          <CustomTable
            columns={columns}
            data={data}
            actions={actions}
            disabled={true}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            noDataComponent={
              <NoDataFound
                title="No Billing Found!"
                buttonText="Add Billing"
                buttonIcon={Add}
                onClick={handleOpen}
              />
            }
          />
        )}




      </Box>
      <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <DialogBox open={open} onClose={handleClose}>
        <AddBilling onClose={handleClose} updateBillings={fetchBillings} />
      </DialogBox>
    </>
  );
};

export default BillingContainer;
